import styled from 'styled-components';

import { ArrowContainerProps } from './utils/interfaces';
import { Box } from '@material-ui/core';

export const Container = styled.div`
  // width: 100%;
  background-color: white;
  padding: 18px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
`;

export const ContainerDocumentMain = styled('div')`
  position: relative;
  border-radius: 0px 0px 16px 0px;
  border: 1px solid #e0e0e0;
  border-top: none;
  width: 86%;
  min-height: 50vh;
  height: 75vh;
  max-height: 75vh;
  &[data-hide-sidebar='true'] {
    width: 100%;
    border-radius: 0px 0px 16px 16px;
  }
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  width: inherit;
  margin: 0;
  padding: 0;
`;

export const SidebarWrapper = styled(Box)`
  width: 14%;
  min-height: 50vh;
  height: 75vh;
  max-height: 75vh;
`;

export const ArrowContainer = styled('div')<ArrowContainerProps>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translateY(-50%);
  padding: 12px;
  margin: 16px;
  z-index: 10;
  border-radius: 50%;
  font-size: 15px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  &[data-disabled='true'] {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ direction }) =>
    direction === 'left'
      ? `
        left: 0;
        padding-left: 14px;
        padding-right: 10px;
      `
      : `
        right: 0;
      `}
`;
